import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconAnalyticsPie';
/** Renders an SVG icon. */
const SvgAnalyticsPie = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.5 28h.583c5.168 0 9.413-3.953 9.875-9H15.5a2.5 2.5 0 0 1-2.5-2.5V7.042c-5.047.462-9 4.707-9 9.875v.583C4 23.299 8.701 28 14.5 28m.583 2H14.5C7.596 30 2 24.404 2 17.5v-.583C2 10.335 7.335 5 13.917 5 14.515 5 15 5.485 15 6.083V16.5a.5.5 0 0 0 .5.5h10.417c.598 0 1.083.485 1.083 1.083C27 24.665 21.665 30 15.083 30"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19 13h9.968A10.835 10.835 0 0 0 19 3.032zm-2 1V2.167C17 1.522 17.522 1 18.167 1 25.254 1 31 6.746 31 13.833c0 .645-.522 1.167-1.167 1.167H18a1 1 0 0 1-1-1"
      />
    </svg>
  );
};
SvgAnalyticsPie.displayName = displayName;
export default SvgAnalyticsPie;
